<!--
 * @Author: zyq yqzhang01@gongsibao.com
 * @Date: 2022-08-09 16:07:56
 * @LastEditors: zyq yqzhang01@gongsibao.com
 * @LastEditTime: 2022-08-26 17:37:10
 * @FilePath: \fe-frame-page\src\views\enterpriseHighNewN\components\fullVersion.vue
 * @Description: 完整版测评页
-->
<template>
  <div class="full-version">
    <!-- 步骤条 -->
    <a-steps type="navigation" size="small" :style="stepStyle">
      <a-step
        title="选择企业"
        status="finish"
        description="select enterprise"
      />
      <a-step
        title="填写测评表"
        status="process"
        description="fill in a form"
      />
      <a-step
        title="生成评估报告"
        status="wait"
        description="generate evaluation report"
      />
    </a-steps>
    <div class="report-name">
      <svg-icon icon-class="gx_1" />国家高新技术企业测评表
      <span>(预计填写时间：1分钟)</span>
    </div>
    <!-- 表单 -->
    <div class="from-box">
      <div class="title">一、企业基本信息</div>
      <from-item label="企业名称全称">
        <a-select
          v-model="fromInfo.q11"
          :disabled="IsInputName"
          style="width: 540px"
          :get-popup-container="getContainer"
          dropdown-class-name="policy_select_box"
          show-search
          :auto-clear-search-value="false"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          placeholder="请输入企业名称，如“汉唐信通（北京）咨询股份有限公司”"
          @search="handleSearch"
          @change="handleChange"
        >
          <a-select-option
            v-for="(company, index) in companyData"
            :key="index"
            :value="company"
          >
            {{ company }}
          </a-select-option>
          <template v-if="optionLoading" #dropdownRender>
            <div v-if="optionLoading" class="spin-box">
              <a-spin />
            </div>
          </template>
        </a-select>
      </from-item>
      <from-item label="企业成立日期">
        <a-date-picker
          :value="fromInfo.q12 ? moment(fromInfo.q12, dateFormat) : ''"
          style="width: 540px"
          placeholder=""
          :disabled="isSelectDate"
          @change="onChangeDate"
        />
      </from-item>
      <from-item label="主要产品(服务)所属国家高新技术领域">
        <a-cascader
          :options="optionList"
          placeholder
          :get-popup-container="getContainer"
          style="width: 540px"
          @change="onChangeSelect"
        />
      </from-item>
      <div class="title">二、科技成果转化</div>
      <from-item
        label="近三年平均科技成果转化数"
        desc="(包括不限于：经登记技术交易合同、已验收科研类项目、经认定科技成果转化项目。分别针对不同产品)"
      >
        <a-select v-model="fromInfo.q21" style="width: 540px">
          <a-select-option
            v-for="(item, index) in selectOption"
            :key="index"
            :value="item"
          >
            {{ item }}
          </a-select-option>
        </a-select>
      </from-item>
      <from-item label="上一年度高新技术产品(服务)占比情况">
        <a-radio-group v-model="fromInfo.q22" :options="radioOption10" />
      </from-item>

      <div class="title">三、知识产权与参与标准制定</div>
      <from-item
        label="1、I 类知识产权数量"
        desc="(包括：发明专利、植物新品种、国家级农作物品种、国家新药、国家一级中药保护品种、集成电路布图设计专有权。利以获得授权证书为准)"
      >
        <a-radio-group v-model="fromInfo.q31" :options="radioOption1" />
      </from-item>
      <from-item
        label="2、 II 类知识产权数量"
        desc="(包括：实用新型专利、外观设计专利、软件著作权。专利以获得授权证书为准）"
      >
        <a-radio-group v-model="fromInfo.q32" :options="radioOption11" />
      </from-item>
      <from-item label="3、知识产权获得方式">
        <a-radio-group v-model="fromInfo.q33" :options="radioOption2" />
      </from-item>
      <from-item
        label="4、企业参与编制国家标准、行业标准、检测方法、技术规范的情况"
      >
        <a-radio-group v-model="fromInfo.q34" :options="radioOption3" />
      </from-item>
      <div class="title">四、研发团队及管理水平管理</div>
      <from-item
        label="1、企业从事研发和相关技术创新活动的科技人员占企业当年职工总数的比例"
      >
        <a-radio-group v-model="fromInfo.q41" :options="radioOption4" />
      </from-item>
      <from-item
        label="2、是否制定了企业研究开发的组织管理制度、建立了研发投入核算体系、编制了研发费用辅助账"
      >
        <a-radio-group v-model="fromInfo.q42" :options="radioOption5" />
      </from-item>
      <from-item label="3、是否设立研发机构、是否开展产学研合作">
        <a-radio-group v-model="fromInfo.q43" :options="radioOption6" />
      </from-item>
      <from-item
        label="4、是否建立了科技成果转化的组织实施与激励奖励制度，建立开放式的创新创业平台"
      >
        <a-radio-group
          v-model="fromInfo.q44"
          class="block"
          :options="radioOption7"
        />
      </from-item>
      <from-item
        label="5、是否建立了科技人员的培养进修、职工技能培训、优秀人才引进，以及人才绩效评价奖励制度"
      >
        <a-radio-group v-model="fromInfo.q45" :options="radioOption12" />
      </from-item>
      <div class="title">五、企业经营情况</div>
      <from-item label="1、 近三年净资产增长率（%）">
        <a-radio-group v-model="fromInfo.q51" :options="radioOption8" />
      </from-item>
      <from-item label="2、近三年销售收入增长率（%）">
        <a-radio-group v-model="fromInfo.q52" :options="radioOption8" />
      </from-item>
      <from-item
        label="3、 企业近三个会计年度研发费用投入总额占同期销售收入总额的比例 （%）"
      >
        <a-radio-group
          v-model="fromInfo.q53"
          class="block"
          :options="radioOption9"
        />
      </from-item>
    </div>
    <!-- 备注 -->
    <div class="remark-box">
      <div>备注：</div>
      <div>
        （1）净资产增长率＝1/2（第二年末净资产÷第一年末净资产＋第三年末净资产÷第二年末净资产）－1
      </div>
      <div>
        （2）销售收入增长率＝1/2（第二年销售收入÷第一年销售收入＋第三年销售收入÷第二年销售收入）－1
      </div>
    </div>

    <div class="btn-box">
      <a-button :loading="loading" @click="handleSubmit"
        >立即获取测评报告</a-button
      >
    </div>

    <!-- 未满一年提示弹窗 -->
    <not-full-model :visible.sync="notFullVisible" />
  </div>
</template>
<script>
import FromItem from "./fromItem.vue";
import NotFullModel from "./notFullModel.vue";
import { throttle } from "lodash-es";
import moment from "moment";
import {
  getCompanyInfo,
  getCorpInfo,
  highTechEnterpriseEvaFull,
} from "@/api/enterpriseHighNew";
import { message } from "ant-design-vue";
export default {
  components: {
    FromItem,
    NotFullModel,
  },
  props: {
    companyName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      stepStyle: {
        boxShadow: "0px -1px 0 0 #e8e8e8 inset",
      },
      dateFormat: "YYYY-MM-DD",
      companyData: [],
      optionLoading: false,
      //  技术领域
      optionList: [],
      optionData: [
        {
          label: "电子信息技术",
          children: [
            "软件",
            "微电子技术",
            "计算机产品及其网络应用技术",
            "通信技术",
            "广播影视技术",
            "新型电子元器件",
            "信息安全技术",
            "智能交通和轨道交通技术",
          ],
        },
        {
          label: "生物与新医药技术",
          children: [
            "医药生物技术",
            "中药、天然药物",
            "化学药研究技术",
            "药物新剂型与制剂创制技术",
            "医疗仪器、设备与医学专业软件",
            "轻工和化工生物技术",
            "农业生物技术",
          ],
        },
        {
          label: "航空航天技术",
          children: ["航空技术", "航天技术"],
        },
        {
          label: "新材料技术",
          children: [
            "金属材料",
            "无机非金属材料",
            "高分子材料",
            "生物医用材料",
            "精细和专用化学品",
            "与文化艺术产业相关的新材料",
          ],
        },
        {
          label: "高技术服务业",
          children: [
            "研发与设计服务",
            "检验检测认证与标准服务",
            "信息技术服务",
            "高技术专业化服务",
            "知识产权与成果转化服务",
            "电子商务与现代物流技术",
            "城市管理与社会服务",
            "文化创意产业支撑技术",
          ],
        },
        {
          label: "新能源及节能技术",
          children: [
            "可再生清洁能源",
            "核能及氢能",
            "新型高效能量转换与储存技术",
            "高效节能技术",
          ],
        },
        {
          label: "资源与环境技术",
          children: [
            "水污染控制与水资源利用技术",
            "大气污染控制技术",
            "固体废弃物处置与综合利用技术",
            "物理性污染防治技术",
            "环境监测及环境事故应急处理技术",
            "生态环境建设与保护技术",
            "清洁生产技术",
            "资源勘查、高效开采与综合利用技术",
          ],
        },
        {
          label: "高新技术改造传统产业",
          children: [
            "工业生产过程控制系统",
            "安全生产技术",
            "高性能、智能化仪器仪表",
            "先进制造业工艺与装备",
            "新型机械",
            "电力系统与设备",
            "汽车及轨道车辆相关技术",
            "高技术船舶与海洋工程装备设计制造技术",
            "传统文化产业改造技术",
          ],
        },
      ],
      // 近三年平均科技成果转化数
      selectOption: ["0项", "1项", "2项", "3项", "4项", "≥5项"],
      // 单选框选项
      radioOption1: ["≥1项", "0项"],
      radioOption2: ["有自主研发", "仅有受让、受赠和并购等"],
      radioOption3: ["有", "无"],
      radioOption4: ["≥10%", "<10%"],
      radioOption5: ["满足1项", "满足2项", "满足3项", "都不满足"],
      radioOption6: [
        "设立研发机构，并开展产学研合作",
        "设立研发机构，但没有开展产学研合作",
        "无研发机构，且没有开展产学研合作",
      ],
      radioOption7: [
        "建立了科技成果转化的组织实施与激励奖励制度，并建立开放式的创新创业平台",
        "建立了科技成果转化的组织实施与激励奖励制度，但无建立开放式的创新创业平台",
        "无科技成果转化的组织实施与激励奖励制度，且无开放式的创新创业平台",
      ],
      radioOption8: ["≥35%", "≥25%", "≥15%", "≥5%", ">0", "≤0"],
      radioOption9: [
        "最近一年销售收入小于5000万元（含）的企业，比例≥5%",
        "最近一年销售收入在5000万元至2亿元（含）的企业，比例占比≥4%",
        "最近一年销售收入在2亿元以上的企业，比例占比≥3%",
        "以上情况都不达标",
      ],
      radioOption10: ["≥60%", "<60%"],
      radioOption11: ["≥5项", "4项", "3项", "2项", "1项", "0项"],
      radioOption12: ["满足1项", "满足2项", "满足3项", "满足4项", "都不满足"],
      // 问题
      fromInfo: {
        q11: "",
        q12: "",
        q13: "",
        q21: "",
        q22: "",
        q31: "",
        q32: "",
        q33: "",
        q34: "",
        q41: "",
        q42: "",
        q43: "",
        q44: "",
        q45: "",
        q51: "",
        q52: "",
        q53: "",
      },
      IsInputName: false, // 公司输入是否禁用
      isSelectDate: false, // 日期选择是否禁用
      loading: false, // 测评loading
      notFullVisible: false, // 未满一年弹窗
    };
  },
  created() {
    // 处理 optionList
    let arr = [];
    this.optionData.map((item, key) => {
      arr.push({
        label: item.label,
        value: item.label,
        children: [],
      });
      item.children.map((item1) => {
        arr[key].children.push({
          label: item1,
          value: item1,
        });
      });
    });
    this.optionList = arr;

    if (this.companyName) {
      this.fromInfo.q11 = this.companyName;
      this.IsInputName = true;
      this.handleChange(this.companyName);
    }
  },
  methods: {
    moment,
    getContainer(node) {
      if (node) {
        return node.parentNode;
      }
      return document.body;
    },
    handleChange(value) {
      if (value) {
        this.isSearch = true;
      }
      Object.assign(this, {
        value,
        companyData: [],
        optionLoading: false,
      });
      getCorpInfo({
        companyName: value,
      }).then((res) => {
        if (res.data.name) {
          this.fromInfo.q12 = res.data.foundedTime;
          this.isSelectDate = true;
        } else {
          this.isSelectDate = false;
        }
      });
    },
    handleSearch: throttle(function (value) {
      if (!value) {
        return;
      }
      this.optionLoading = true;
      let data = {
        name: value,
      };
      getCompanyInfo(data)
        .then((res) => {
          this.optionLoading = false;
          if (res.data) this.companyData = [...new Set(res.data)];
        })
        .catch((err) => console.log(err));
    }, 1000),

    onChangeDate(date, dateString) {
      this.fromInfo.q12 = dateString;
    },
    onChangeSelect(e) {
      this.fromInfo.q13 = e.join("/");
    },

    // 是否有空值
    isEmpty(data) {
      let falg = true;
      for (const key in data) {
        const element = data[key];
        if (!element && element !== 0) {
          falg = false;
        }
      }
      if (!falg) {
        message.error("您有未填写的企业信息，请补全完成");
      }
      return falg;
    },

    // 判断是否满一年
    isFullYear(date) {
      if (
        (new Date().getTime() - new Date(date).getTime()) /
          (24 * 60 * 60 * 1000) >
        365
      ) {
        return true;
      }
      this.notFullVisible = true;
      return false;
    },

    // 点击立即测评
    async handleSubmit() {
      if (!this.isEmpty(this.fromInfo)) {
        return;
      }
      // 是否满一年
      if (!this.isFullYear(this.fromInfo.q12)) {
        return;
      }
      this.loading = true;
      let data = [];
      for (const key in this.fromInfo) {
        let code = key.substr(1);
        code = code.slice(0, 1) + "-" + code.slice(1);
        // code = code.slice(0, 3) + '-' + code.slice(3)
        data.push({
          code: code,
          content: this.fromInfo[key],
        });
      }
      let res = await highTechEnterpriseEvaFull(data);
      this.loading = false;
      this.$router.push({
        path: `/enterpriseHighNew/result`,
        query: {
          reportId: res.data.reportId,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.full-version {
  padding: 30px;
  ::v-deep
    .ant-steps-horizontal:not(.ant-steps-label-vertical)
    .ant-steps-item-description {
    max-width: unset !important;
    padding-bottom: 10px;
  }

  ::v-deep.ant-steps-navigation .ant-steps-item::before {
    background-color: #3371ff;
  }
  ::v-deep.ant-steps-item-finish .ant-steps-item-icon {
    border-color: #3371ff;
  }
  ::v-deep.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: #3371ff;
  }
  ::v-deep.ant-steps-item-process .ant-steps-item-icon {
    background: #3371ff;
    border-color: #3371ff;
  }
  ::v-deep.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-color: #e0e0e0 !important;
  }
  ::v-deep.ant-input {
    border-color: #e0e0e0 !important;
  }

  ::v-deep .ant-steps-navigation .ant-steps-item.ant-steps-item-active::before {
    width: 0;
  }
  ::v-deep .ant-steps-navigation .ant-steps-item.ant-steps-item-process::before {
    width: 100%;
    left: 0;
  }
  .report-name {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 16px;
    svg {
      margin-right: 10px;
      margin-top: 38px;
    }
    span {
      font-size: 14px;
      color: #999999;
    }
  }
  .from-box {
    .title {
      height: 16px;
      font-size: 16px;
      color: #333333;
      line-height: 16px;
      margin-top: 40px;
      font-weight: 600;
      &::before {
        content: "";
        display: inline-block;
        width: 4px;
        height: 14px;
        background: #0072f7;
        margin-right: 9px;
      }
    }
  }
  .remark-box {
    height: 121px;
    background: #f7fafe;
    padding: 15px 20px;
    font-size: 14px;
    color: #666666;
    line-height: 30px;
    margin-top: 25px;
  }
  .block {
    ::v-deep .ant-radio-wrapper {
      display: block;
      line-height: 30px;
    }
  }
  .btn-box {
    margin-top: 40px;
    text-align: center;
    ::v-deep .ant-btn {
      background: #0072f7;
      color: #fff;
      width: 224px;
      height: 40px;
      border-radius: 2px;
    }
  }
}
</style>